import { css } from 'styled-components';

export const guideArticleBodyStyles = css`
  &.ql-editor {
    padding: 0;
    font-size: 16px;
    color: #1e293b;
    line-height: 1.6;
    overflow-x: auto;
    --guide-flow-space: 1.05em;
  }

  &.ql-editor > * {
    margin-top: 0;
    margin-bottom: 0;
  }

  /* Keep preview and published article rhythm aligned with one shared block flow rule. */
  &.ql-editor > * + * {
    margin-top: var(--guide-flow-space);
  }

  &.ql-editor > *:first-child {
    margin-top: 0;
  }

  &.ql-editor > *:last-child {
    margin-bottom: 0;
  }

  &.ql-editor h1,
  &.ql-editor h2,
  &.ql-editor h3,
  &.ql-editor h4 {
    color: #0f172a;
    line-height: 1.2;
    margin-top: 1.7em;
    margin-bottom: 0.7em;
  }

  &.ql-editor p,
  &.ql-editor ul,
  &.ql-editor ol,
  &.ql-editor pre,
  &.ql-editor blockquote,
  &.ql-editor table,
  &.ql-editor .ql-code-block-container {
    margin-top: 0;
    margin-bottom: 0;
  }

  &.ql-editor ul,
  &.ql-editor ol {
    padding-left: 1.5em;
  }

  &.ql-editor li {
    margin-top: 0;
    margin-bottom: 0;
  }

  &.ql-editor li + li {
    margin-top: 0.35em;
  }

  &.ql-editor li > p {
    margin: 0;
  }

  &.ql-editor li > ul,
  &.ql-editor li > ol {
    margin-top: 0.35em;
    margin-bottom: 0;
  }

  &.ql-editor a {
    color: #0f766e;
  }

  &.ql-editor img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 20px auto;
    border-radius: 18px;
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
  }

  &.ql-editor table {
    width: max-content;
    min-width: 100%;
    border-collapse: collapse;
    display: table;
    border: 1px solid #cbd5e1;
    border-radius: 16px;
    background: #fff;
  }

  &.ql-editor thead {
    background: #f8fafc;
  }

  &.ql-editor th,
  &.ql-editor td {
    padding: 12px 14px;
    border: 1px solid #dbe4ea;
    text-align: left;
    vertical-align: top;
  }

  &.ql-editor th {
    color: #0f172a;
    font-weight: 700;
  }

  &.ql-editor blockquote {
    border-left: 4px solid #2c9fa4;
    padding-left: 18px;
    color: #475569;
    background: #f8fafc;
    border-radius: 0 14px 14px 0;
  }

  &.ql-editor pre.ql-syntax {
    border-radius: 16px;
    padding: 18px;
    overflow-x: auto;
  }

  &.ql-editor code,
  &.ql-editor .ql-code-block-container,
  &.ql-editor .ql-code-block {
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
  }

  &.ql-editor code {
    display: inline-block;
    padding: 0.16em 0.45em;
    border-radius: 8px;
    background: #e2e8f0;
    color: #0f172a;
    font-size: 0.92em;
    white-space: break-spaces;
  }

  &.ql-editor pre,
  &.ql-editor pre.ql-syntax,
  &.ql-editor .ql-code-block-container {
    margin: 1.25em 0;
    padding: 18px 20px;
    border-radius: 18px;
    border: 1px solid #0f172a;
    background: #0f172a;
    color: #e2e8f0;
    overflow-x: auto;
    white-space: pre;
    tab-size: 4;
  }

  &.ql-editor pre code,
  &.ql-editor pre.ql-syntax code,
  &.ql-editor .ql-code-block-container code {
    display: inline;
    padding: 0;
    border-radius: 0;
    background: transparent;
    color: inherit;
    font-size: inherit;
    white-space: inherit;
  }

  &.ql-editor .ql-code-block-container {
    display: grid;
    gap: 0;
  }

  &.ql-editor .ql-code-block {
    white-space: pre;
    overflow-wrap: normal;
    word-break: normal;
  }
`;
